var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col flex-1"},[_c('AssetSelectionList',{ref:"list",attrs:{"module-name":_vm.moduleName,"fetch-fn":_vm.fetchAssetFn,"searchable":false,"scrollable":"","show-no-data":"","has-actions":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }